/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufEmpty from '../../../google/protobuf/empty.pb';
import * as EdukitaPaulaBackendCommonFilter from '../common/filter.pb';
import * as EdukitaPaulaBackendGaragecacheEntities from '../garagecache/entities.pb';
import * as EdukitaPaulaBackendGaragecacheProfiles from '../garagecache/profiles.pb';
import * as EdukitaPaulaBackendV3Common from './common.pb';
import * as EdukitaPaulaBackendV3LevelTrackerService from './level_tracker_service.pb';
import * as fm from '@generated/fetch.pb';

export type LearningSummary = {
    id?: string;
    garageStudentId?: number;
    studentName?: string;
    garageParentId?: number;
    parentName?: string;
    parentPhoneNumber?: string;
    studentSchool?: string;
    garageLevelLabel?: string;
    garagePartnerId?: number;
    garagePartnerInfo?: EdukitaPaulaBackendGaragecacheEntities.GaragePartnerInfo;
    academicMonth?: string;
    observationNote?: string;
    coreStrengths?: string;
    areasToReinforce?: string;
    observationNoteIdn?: string;
    coreStrengthsIdn?: string;
    areasToReinforceIdn?: string;
    currentUnitObjective?: LearningUnitObjectiveProgress[];
    learningObjectiveProgress?: EdukitaPaulaBackendV3LevelTrackerService.LearningObjectiveProgress[];
    levelObjectiveCompositeScore?: number;
    tenureInLevel?: number;
    levelAction?: string;
    skillAssessedPercentage?: number;
    compositeScoreVerdict?: string;
    status?: string;
    approvedByTeacherId?: number;
    approvedAt?: string;
    releasedBy?: string;
    releaseDate?: string;
    releasedAt?: string;
    openedAt?: string;
    garageTeacherProfiles?: EdukitaPaulaBackendGaragecacheProfiles.GarageTeacherProfile[];
    estimatedLevelUpDate?: string;
    levelRecommendedEndDate?: string;
    attendanceSessions?: EdukitaPaulaBackendV3Common.AttendanceSession[];
    subject?: string;
    nextLevelRecommendation?: string;
    currentLevelLabel?: string;
    nextLevelLabel?: string;
    currentMonth?: number;
    totalMonth?: number;
    evaluationMonth?: string;
    attendance?: EdukitaPaulaBackendV3Common.AttendanceCounts;
    loStats?: LearningSummaryLOStats;
    learningObjectives?: LearningSummaryObjective[];
    teacherReview?: LearningSummaryTeacherReview;
};

export type LearningSummaryLOStats = {
    notStartedDescription?: string;
    emergingDescription?: string;
    developingDescription?: string;
    proficientDescription?: string;
};

export type LearningSummaryObjective = {
    code?: string;
    title?: string;
    statement?: string;
    status?: string;
    progressPercentage?: number;
};

export type LearningSummaryTeacher = {
    id?: number;
    name?: string;
    avatarUrl?: string;
};

export type LearningSummaryTeacherReview = {
    positive?: string;
    improvement?: string;
    nextSteps?: string;
    teachers?: LearningSummaryTeacher[];
};

export type LearningUnitObjectiveProgress = {
    loCode?: string;
    score?: number;
    assessed?: boolean;
    assessmentsCount?: number;
};

export type GetLearningSummariesRequest = {
    academicMonth?: string;
    garagePartnerId?: number;
    garageLevelLabels?: string[];
    garageTeacherIds?: number[];
    status?: string;
    garageStudentId?: number;
    garageStudentName?: string;
    garageParentName?: string;
    garageParentPhoneNumber?: string;
    page?: number;
    pageSize?: number;
    sort?: string[];
    subjects?: string[];
    includeLearningObjectiveProgress?: boolean;
    locale?: string;
    fallbackLocale?: string;
    tenureInLevel?: number;
};

export type GetLearningSummariesResponse = {
    learningSummaries?: LearningSummary[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type GetNextLevelOptionsRequest = {
    currentLevel?: string;
};

export type GetNextLevelOptionsResponse = {
    nextLevelOptions?: string[];
};

export type GetLearningSummaryRequest = {
    id?: string;
};

export type UpdateLearningSummaryRequest = {
    id?: string;
    observationNote?: string;
    coreStrengths?: string;
    areasToReinforce?: string;
    levelAction?: string;
    status?: string;
    approvedByTeacherId?: number;
    observationNoteIdn?: string;
    coreStrengthsIdn?: string;
    areasToReinforceIdn?: string;
    nextLevel?: string;
    releaseDate?: string;
    openedAt?: string;
};

export type UpdateLearningSummaryResponse = {
    learningSummary?: LearningSummary;
};

export type GetLearningSummaryFiltersResponse = {
    filters?: EdukitaPaulaBackendCommonFilter.FilterDefinition[];
};

export type MathBookInfo = {
    id?: number;
    name?: string;
};

export type GetMathLearningSummariesRequest = {
    academicMonth?: string;
    studentId?: number;
    partnerId?: number;
    status?: string;
    page?: number;
    pageSize?: number;
    teacherIds?: number[];
    garageStudentName?: string;
    garageParentName?: string;
    garageStudentId?: number;
    sort?: string[];
    tenureInLevel?: number;
};

export type MathLearningSummaryListItem = {
    id?: string;
    garageStudentId?: number;
    garageParentId?: string;
    garagePartnerId?: number;
    garageTeacherIds?: number[];
    studentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageStudentProfile;
    parentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageParentProfile;
    teacherProfiles?: EdukitaPaulaBackendGaragecacheProfiles.GarageTeacherProfile[];
    partnerInfo?: EdukitaPaulaBackendGaragecacheEntities.GaragePartnerInfo;
    garageLevelLabel?: string;
    tenureInLevel?: number;
    academicMonth?: string;
    summaryStartDate?: string;
    summaryEndDate?: string;
    attendanceSessions?: EdukitaPaulaBackendV3Common.AttendanceSession[];
    attendance?: EdukitaPaulaBackendV3Common.AttendanceCounts;
    bookIds?: number[];
    bookInfos?: MathBookInfo[];
    totalWorksheetsCompleted?: number;
    totalPagesCompleted?: number;
    supplementCount?: number;
    totalScore?: number;
    maxPossibleScore?: number;
    scorePercentage?: number;
    observationNote?: string;
    coreStrengths?: string;
    areasToReinforce?: string;
    status?: string;
    releaseDate?: string;
    approvedByTeacherId?: number;
    approvedAt?: string;
    releasedBy?: string;
    releasedAt?: string;
    openedAt?: string;
};

export type GetMathLearningSummariesResponse = {
    items?: MathLearningSummaryListItem[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type UpdateMathLearningSummaryRequest = {
    id?: string;
    status?: string;
    approvedByTeacherId?: number;
    releaseDate?: string;
    observationNote?: string;
    coreStrengths?: string;
    areasToReinforce?: string;
    openedAt?: string;
};

export type UpdateMathLearningSummaryResponse = {
    item?: MathLearningSummaryListItem;
};

export type GetMathLearningSummaryDetailRequest = {
    id?: string;
};

export type GetMathLearningSummaryDetailResponse = {
    id?: string;
    observationNote?: string;
    coreStrengths?: string;
    areasToReinforce?: string;
    status?: string;
};

export class LearningSummaryService {
    static GetLearningSummaryFilters(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<GetLearningSummaryFiltersResponse> {
        return fm.fetchRequest<GetLearningSummaryFiltersResponse>(
            `/v3/learning-summary-filters?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetLearningSummaries(
        this: void,
        req: GetLearningSummariesRequest,
        initReq?: fm.InitReq
    ): Promise<GetLearningSummariesResponse> {
        return fm.fetchRequest<GetLearningSummariesResponse>(
            `/v3/learning-summaries?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetLearningSummary(
        this: void,
        req: GetLearningSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<LearningSummary> {
        return fm.fetchRequest<LearningSummary>(
            `/v3/learning-summaries/${req.id}?${fm.renderURLSearchParams(req, [
                'id',
            ])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static UpdateLearningSummary(
        this: void,
        req: UpdateLearningSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<UpdateLearningSummaryResponse> {
        return fm.fetchRequest<UpdateLearningSummaryResponse>(
            `/v3/learning-summaries/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetNextLevelOptions(
        this: void,
        req: GetNextLevelOptionsRequest,
        initReq?: fm.InitReq
    ): Promise<GetNextLevelOptionsResponse> {
        return fm.fetchRequest<GetNextLevelOptionsResponse>(
            `/v3/learning-summaries/next-level-options?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMathLearningSummaryFilters(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<GetLearningSummaryFiltersResponse> {
        return fm.fetchRequest<GetLearningSummaryFiltersResponse>(
            `/v3/math/learning-summary-filters?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMathLearningSummaries(
        this: void,
        req: GetMathLearningSummariesRequest,
        initReq?: fm.InitReq
    ): Promise<GetMathLearningSummariesResponse> {
        return fm.fetchRequest<GetMathLearningSummariesResponse>(
            `/v3/math/learning-summaries?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static UpdateMathLearningSummary(
        this: void,
        req: UpdateMathLearningSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<UpdateMathLearningSummaryResponse> {
        return fm.fetchRequest<UpdateMathLearningSummaryResponse>(
            `/v3/math/learning-summaries/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetMathLearningSummaryDetail(
        this: void,
        req: GetMathLearningSummaryDetailRequest,
        initReq?: fm.InitReq
    ): Promise<GetMathLearningSummaryDetailResponse> {
        return fm.fetchRequest<GetMathLearningSummaryDetailResponse>(
            `/v3/math/learning-summaries/${req.id}?${fm.renderURLSearchParams(req, [
                'id',
            ])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
